import S_base from '@/services/wasaapi/__base';

export default {
  async index({ params, pagination = false } = {}) {
    const _params = {
      ...params,
    };
    const res = await S_base.index({
      modelName: 'article_version',
      params: _params,
      pagination,
    });
    return res;
  },
  async update(id, data) {
    const res = await S_base.update({
      modelName: 'article_version',
      modelId: id,
      payload: data,
    });
    return res;
  },
  async unbindArticleVerFromAct($event) {
    try {
      const { parentId: actVersionId, itemId: articleVersionId } = $event;
      if (!actVersionId || !articleVersionId) {
        return Promise.reject(new Error(
          'actVersionId and articleVersionId are required'
        ));
      }
      const act_versions = { act_versions: [actVersionId] };
      await S_base.create({
        url: `article_version/${articleVersionId}/remove`,
        data: act_versions,
      });
    } catch (error) {
      alert(error);
    }
  },
  async delete(versionId) {
    try {
      await S_base.delete({ modelName: 'article_version', modelId: versionId });
    } catch (error) {
      alert(error);
    }
  },
};
